import { OpsResultsTable } from './Data'
import { useContext } from 'react'

import React from 'react'
import { Text, Tip } from 'grommet'
import { departments, getDepartmentForIdV2 } from '../api/retail'

import { AppContext } from '../libs/context'
import { labelByMode } from '../libs/common'

export const StipendReportTable = (props) => {
  const { demoMode } = useContext(AppContext)
  const exportExcelConfig = {
    showExport: true,
    columns: [
      { header: 'Receiver ID', key: 'receiver' },
      { header: 'Receiver', key: 'receiver_name' },
      { header: 'Receiver Diversion Type', key: 'receiver_diversion_type' },
      { header: 'Lead Charity', key: 'is_lead_charity' },

      { header: 'Store ID', key: 'store' },
      { header: 'Store', key: 'store_name' },
      { header: 'Store Type', key: 'store_type' },
      { header: 'Store Start Date', key: 'store_start_date' },
      { header: 'ReportMonth', key: 'year_month' },

      { header: 'Went_Store__incl', key: 'reason_1' },
      { header: 'Did_Not_Go_Store', key: 'reason_2' },
      { header: 'No_Data_Available__incl', key: 'reason_3' },
      { header: 'Ops_Platform', key: 'reason_4' },
      { header: 'Avg_Wt_@_72_Hr', key: 'reason_5' },
      { header: 'Replacement', key: 'reason_6' },
      { header: 'Ops_Support', key: 'reason_7' },
      { header: 'Zero_Wt_@_72_Hr', key: 'reason_8' },
      { header: 'Entered_Using_DT_App__incl', key: 'reason_null' },

      { header: 'Code', key: 'schedule_code' },
      { header: 'Service days', key: 'expected_service_days' },
      { header: 'Actual Service Days', key: 'actual_service_days' },
      { header: 'Non Service Days', key: 'expected_non_service_days' },
      { header: 'Actual Non Service Days', key: 'actual_non_service_days' }
    ],
    fileName: 'Stipend_Report',
    workSheetName: 'Report'
  }

  return (
    <OpsResultsTable
      heading={labelByMode('stipened', demoMode)}
      {...props}
      apiPath={'retail/stipend-report'}
      //   apiParams={{ receiver_type: 'HUB' }}
      apiFilters={[]}
      showColumns={[
        {
          property: 'item_id',
          header: <Text weight={'bold'}>Item</Text>
        },
        {
          property: 'receiver_name',
          header: <Text weight={'bold'}>{demoMode ? 'Vendor' : 'Receiver'}</Text>
        },
        {
          property: 'receiver_type',
          header: <Text weight={'bold'}>Receiver Type</Text>
        },
        {
          property: 'receiver_diversion_type',
          header: <Text weight={'bold'}>Diversion Type</Text>
        },
        {
          property: 'is_lead_charity',
          header: <Text weight={'bold'}>{demoMode ? 'Lead' : 'Lead Charity'}</Text>
        },
        {
          property: 'store_name',
          header: <Text weight={'bold'}>Store Name</Text>
        },
        {
          property: 'schedule_code',
          header: <Text weight={'bold'}>Schedule Code</Text>
        },

        {
          property: 'expected_service_days',
          header: <Text weight={'bold'}>expected_service_days</Text>
        },
        {
          property: 'actual_service_days',
          header: <Text weight={'bold'}>actual_service_days</Text>
        },
        {
          property: 'expected_non_service_days',
          header: <Text weight={'bold'}>expected_non_service_days</Text>
        },
        {
          property: 'actual_non_service_days',
          header: <Text weight={'bold'}>actual_non_service_days</Text>
        }
      ]}
      exportExcelConfig={exportExcelConfig}
    />
  )
}
